import "./App.css";
import Route1 from "./Component/Route/Route";
import { ToastContainer } from "react-toastify";

function App() {
  return (
    <div className="App">
      <ToastContainer />
      <Route1 />
    </div>
  );
}

export default App;
